// extracted by mini-css-extract-plugin
export default {"PFSWhoWeAre":"PFSWhoWeAre_PFSWhoWeAre__70RIM","IntroText":"PFSWhoWeAre_IntroText__MWjEA"};